import { put } from 'redux-saga/effects';
import {
  setStatisticsTotalToggled,
  setStatisticsDetailToggled
} from './reducer';
import { history } from '../../../utilities/history';

export function* handleLoadStatisticsSummary() {
  try {
    const statisticsTotalToggled = localStorage.getItem(
      'statisticsTotalToggled'
    );
    const statisticsDetailToggled = localStorage.getItem(
      'statisticsDetailToggled'
    );
    if (statisticsTotalToggled === null || statisticsTotalToggled === 'true') {
      yield put(setStatisticsTotalToggled());
    }
    if (statisticsDetailToggled === null || statisticsDetailToggled === 'true')
      yield put(setStatisticsDetailToggled());
  } catch (error) {
    history.push('/error');
  }
}
